import React from "react";

function Loader(props: { inline?: boolean }) {
	return (
		<span data-test="basket-loader" className={`c-loader ${props.inline ? "c-loader--inline" : ""}`}>
			<span className="u-visuallyhidden">Loading...</span>
		</span>
	);
}

export default Loader;
